var _filter, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "starGold",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFE55C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF8C00"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "starHighlight",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "starShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#B8860B",
    floodOpacity: 0.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4 L39.5 24.5 L61 26 L44 41 L49 62 L32 51 L15 62 L20 41 L3 26 L24.5 24.5 Z",
    fill: "url(#starGold)",
    stroke: "#DAA520",
    strokeWidth: 1.5,
    filter: "url(#starShadow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8 L37.5 24 L54 25.5 L42 37 L32 30 Z",
    fill: "url(#starHighlight)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHd);
export default __webpack_public_path__ + "static/media/star-hd.5a6eed86.svg";
export { ForwardRef as ReactComponent };